import { VerificationState } from '../../utilities/constants';

const KYC_APPROVED_STATES = [
  VerificationState.VERIFIED,
  VerificationState.EDD_REQUIRED,
  VerificationState.EDD_SUBMITED,
];

const AWAITING_DECISION_STATES = [VerificationState.PENDING, VerificationState.CHECKED];

/**
 * Where the pending screen should send the user, or null to keep waiting.
 *
 * The approved set mirrors baanxserver's hasPassedKYC, which issues an
 * authorization code for the two EDD states as well as VERIFIED. Returning on
 * VERIFIED alone would abandon a journey the backend would have completed.
 *
 * Only an interrupted OAuth journey waits. Without a stored interaction the
 * screen keeps its original behaviour of leaving for the dashboard on the
 * first poll, whatever the state.
 */
export const nextPendingDestination = (verificationState, oauthReturnUrl) => {
  if (!oauthReturnUrl) {
    return '/';
  }

  if (KYC_APPROVED_STATES.includes(verificationState)) {
    return oauthReturnUrl;
  }

  if (AWAITING_DECISION_STATES.includes(verificationState)) {
    return null;
  }

  return '/';
};

export default nextPendingDestination;
